import { useTranslation } from "@msuite/ui/localization";
import { Tag } from "@msuite/ui/tag";
import { INCOMING_INVOICE_APPROVAL_STATE_COLOR } from "@msuite/utils/incoming-invoices";
import type { Enums } from "@msuite/utils/types";

/** Props Interface */
interface IncomingInvoiceApprovalStateTagProps {
	state: Enums<"incomingInvoiceApprovalState">;
}

export function IncomingInvoiceApprovalStateTag({ state }: IncomingInvoiceApprovalStateTagProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<Tag
			size="xs"
			color={INCOMING_INVOICE_APPROVAL_STATE_COLOR[state]}
			variant="plain"
		>
			{t(`incoming_invoices.approval_state.${state}`)}
		</Tag>
	);
}
